import React, { PropsWithChildren } from "react";
import cx from "classnames";

interface Props {
  isSelected?: boolean;
}

const GalleryImageButton = ({
  isSelected,
  children,
}: PropsWithChildren<Props>) => {
  const buttonClass = cx(
    "h-20 rounded-[10px] border border-white/20 opacity-60 hover:opacity-100",
    { "outline outline-2 !opacity-100 outline-white": isSelected }
  );

  return <button className={buttonClass}>{children}</button>;
};

export default GalleryImageButton;
